import React from 'react';
import PropTypes from 'prop-types';

const ContainerError = ({ errorMessage, phoneNumber }) => (
  <div className="alert alert--danger">
    <span className="alert__message">
      {errorMessage} <a href={`tel:${phoneNumber}`}>call {phoneNumber}</a>
    </span>
  </div>
);

ContainerError.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  phoneNumber: PropTypes.string.isRequired,
};

export default ContainerError;
